"use client"

import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getWhatsappTempletesAction } from "../../services/action/common"
import DashboardLayout from "../layouts/DashboardLayout"
import ContactsManagement from "./contact/contact-management"
import TemplatesManagement from "./templetes/templates-managent"
import { Menu, X } from "lucide-react"
import { handlePopupModalAction } from "../../services/action/event"

export default function WhatsappTemplate() {
  const [activeTab, setActiveTab] = useState("contacts")
  const [toast, setToast] = useState({
    show: false,
    title: "",
    message: "",
  })
  const dispatch = useDispatch()
  const { templeteList } = useSelector((state) => state.commonReducer)
    const [selectedNewNumber, setSelectedNewNumber] = useState(null);
    const [showChangeMobileModal, setShowChangeMobileModal] = useState(false);

  // WhatsApp Number ID state
  const [whatsappNumberId, setWhatsappNumberId] = useState(
    process.env.NEXT_PUBLIC_WHATSAPP_PHONE_NUMBER_ID || "640960762422977",
  )

  const getTemplete=()=>{
    dispatch(getWhatsappTempletesAction({data:selectedNewNumber}))
  }
  useEffect(() => {

    if(selectedNewNumber && !showChangeMobileModal){
      dispatch(getWhatsappTempletesAction({data:selectedNewNumber}))
    }
   
  }, [selectedNewNumber?.NUMBER])

  // Auto-hide toast after 3 seconds
  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ ...toast, show: false })
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [toast])

  const showToast = (title, message) => {
    setToast({ show: true, title, message })
  }

  return (
    <DashboardLayout>
      <div className="container mx-auto p-2 sm:p-4 lg:p-6 bg-gray-50 min-h-screen">
        {/* Toast Notification */}
        {toast.show && (
          <ToastNotification
            title={toast.title}
            message={toast.message}
            onClose={() => setToast({ ...toast, show: false })}
          />
        )}

        <div className="w-full">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
            <div>
              
              <h1 className="text-2xl font-bold text-[#001B3D]">
              <button
                            onClick={() =>
                              dispatch(handlePopupModalAction({ isOpenSidebar: true }))
                            }
                            className="p-2 hover:text-white rounded-md hover:bg-[#0A2547] transition-colors lg:hidden"
                          >
                            <Menu className="w-6 h-6" />
                          </button>
                WhatsApp Management</h1>
              <p className="text-gray-500 mt-1">Manage contacts and templates for your campaigns</p>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-1 grid grid-cols-2 w-full sm:w-auto shadow-sm">
              <button
                onClick={() => setActiveTab("contacts")}
                className={`px-4 py-2.5 text-sm font-medium rounded-md transition-all duration-200 ${
                  activeTab === "contacts" ? "bg-[#001B3D] text-white shadow-sm" : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                Contacts
              </button>
              <button
                onClick={() => setActiveTab("templates")}
                className={`px-4 py-2.5 text-sm font-medium rounded-md transition-all duration-200 ${
                  activeTab === "templates" ? "bg-[#001B3D] text-white shadow-sm" : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                Templates
              </button>
            </div>
          </div>

          {/* Contacts Tab */}
          {activeTab === "contacts" && (
            <ContactsManagement 
            showChangeMobileModal={showChangeMobileModal}
            setShowChangeMobileModal={setShowChangeMobileModal}
            getTemplete={getTemplete}
            selectedNewNumber={selectedNewNumber} setSelectedNewNumber={setSelectedNewNumber} showToast={showToast} templeteList={templeteList} whatsappNumberId={whatsappNumberId} />
          )}

          {/* Templates Tab */}
          {activeTab === "templates" && <TemplatesManagement showToast={showToast} templeteList={templeteList} />}
        </div>
      </div>
    </DashboardLayout>
  )
}

function ToastNotification({ title, message, onClose }) {
  return (
    <div className="fixed top-4 right-4 z-50 bg-white rounded-lg shadow-lg border border-gray-200 p-4 max-w-sm w-full animate-[fadeIn_0.3s_ease-in-out] transform transition-all">
      <div className="flex justify-between items-start">
        <div>
          <h3 className="font-medium text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500 mt-1">{message}</p>
        </div>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-500 transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

